'use client';
import { Suspense, type ReactNode } from 'react';
import { useRouter } from 'next/navigation';
import { ProvidersLazySection } from '@/widgets/game-sections';
import { NotAllowedModal } from '@/entities/game/ui/not-allowed-modal';
import { CashbackModal } from '@/entities/cashback/ui/cashback-modal';
import { Banners } from '@/entities/minibanner/ui/banners';
import { StartQueryInitializer } from '@/features/start-query-initializer';
import AuthButtons from '@/shared/ui/auth-buttons';
import { H1Content } from '@/shared/ui/h1-content';
import { useVisibleState } from '@/shared/hooks/useVisibleState';
import type { PageMetadata } from '@/shared/hooks/usePageMetadata';
import { Wrapper } from './styles';

interface GamesPageShellProps {
  initialPageMetadata?: PageMetadata | null;
  beforeBanners?: ReactNode;
  renderSections: (openNotAllowedModal: () => void) => ReactNode;
}

const GamesPageShell = ({
  initialPageMetadata = null,
  beforeBanners,
  renderSections,
}: GamesPageShellProps) => {
  const router = useRouter();
  const notAllowedModal = useVisibleState();
  const cashbackModal = useVisibleState();

  const closeCashbackModal = () => {
    cashbackModal.close();
    router.push('/');
  };

  return (
    <Wrapper>
      <Suspense fallback={null}>
        <StartQueryInitializer onCashbackOpen={cashbackModal.open} />
      </Suspense>

      <AuthButtons />
      {beforeBanners}
      <Banners />
      <H1Content initialMetadata={initialPageMetadata} />

      {renderSections(notAllowedModal.open)}

      <ProvidersLazySection />

      <NotAllowedModal
        visible={notAllowedModal.visible}
        onClose={notAllowedModal.close}
        onOpen={notAllowedModal.open}
      />
      <CashbackModal
        visible={cashbackModal.visible}
        onClose={closeCashbackModal}
      />
    </Wrapper>
  );
};

export { GamesPageShell };
